import React, { useContext } from 'react';

import { Trash2 } from 'lucide-react';
import Textarea from '../../components/Textarea';
import ConfirmationModal from '../../components/ConfirmationModal';
import GlobalContext from '../GlobalContext';

export const getRenderBlockGKG = (
  items,
  editMode,
  currentTab,
  updateStrategy,
  removeStrategy,
  backgroundBlock,
  borderColorBlock,
  titleTabsColor,
  textColor,
  textStyle,
) => {
  const { locales } = useContext(GlobalContext);
  return items.map((item, index) => (
    <div
      key={index}
      className="bmc-page-gkgtabs-content-block"
      style={{
        backgroundColor: backgroundBlock,
        borderColor: borderColorBlock,
      }}
    >
      {editMode && items.length > 1 && (
        <div className="modal">
          <ConfirmationModal
            className="hover:bg-muted-lighter/60 text-muted-darker mb-2"
            body={locales.common.deleteConfirmation}
            confirmText="Delete"
            onConfirm={() =>
              removeStrategy({
                index,
                collectionName: `${currentTab}Strategies`,
              })
            }
          >
            <Trash2 className="w-5 h-auto" />
          </ConfirmationModal>
        </div>
      )}
      {editMode ? (
        <Textarea
          value={item.name}
          delay={700}
          className={`bmc-form-textarea ${textStyle} custom-font-body`}
          placeholder={locales.getKeepGrow.titlePlaceholder}
          onChange={(e) =>
            updateStrategy({
              index,
              name: 'name',
              value: e.target.value,
              collectionName: `${currentTab}Strategies`,
            })
          }
        />
      ) : (
        <div
          className={`bmc-page-gkgtabs-content-block-title ${textStyle} custom-font-body`}
          style={{ color: titleTabsColor }}
        >
          {item.name}
        </div>
      )}

      {editMode ? (
        <div className="textarea-description">
          <Textarea
            value={item.description}
            delay={700}
            className={`bmc-form-textarea ${textStyle} custom-font-body`}
            placeholder={locales.getKeepGrow.descriptionPlaceholder}
            onChange={(e) =>
              updateStrategy({
                index,
                name: 'description',
                value: e.target.value,
                collectionName: `${currentTab}Strategies`,
              })
            }
          />
        </div>
      ) : (
        <div
          className={`bmc-page-gkgtabs-content-block-text text-base font-normal ${textStyle} custom-font-body`}
          style={{ color: textColor }}
        >
          {item.description}
        </div>
      )}
    </div>
  ));
};
